module.exports = __webpack_public_path__ + "static/media/more.cbbee79d.jpg";